module.exports = __webpack_public_path__ + "static/vow-009fef2b97b6b07911f3f07ef5f252ce.png";